export default {
  id: 189,
  title: 'Target #189 - Triangle Hook',
  url: 'https://cssbattle.dev/play/189',
  colors: ['#D669EC', '#FDFBF8'],
  solution:
    '<style>body{background:linear-gradient(-153.4deg,#d669ec 159px,transparent 159px),linear-gradient(-26.6deg,#d669ec 159px,transparent 159px),linear-gradient(-90deg,#fdfbf8 105px,#d669ec 105px 125px,#fdfbf8 125px 235px,#d669ec 235px,transparent 235px),linear-gradient(153.4deg,#d669ec 159px,transparent 159px),linear-gradient(26.6deg,#d669ec 159px,transparent 159px),linear-gradient(transparent 140px,#fdfbf8 140px 160px,transparent 160px),linear-gradient(90deg,transparent 135px,#d669ec 135px),linear-gradient(153.4deg,#fdfbf8 172px,transparent 172px),linear-gradient(26.6deg,#fdfbf8 172px,#d669ec 172px)}</style>',
}
